import { Component } from '@angular/core';

@Component({
  selector: 'section#not-found',
  standalone: true,
  imports: [],
  templateUrl: './not-found.component.html'
})
export class NotFoundComponent {}
